import { Button, Group, Select, Textarea, Title } from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { IconAlertTriangle, IconCheck } from "@tabler/icons-react";
import { useMutation } from "@tanstack/react-query";
import * as React from "react";
import ReCAPTCHA from "react-google-recaptcha";

export function Feedback() {
  const form = useForm({
    initialValues: {
      subject: "",
      message: "",
    },
    validate: {
      subject: (value) => value.trim().length === 0,
    },
  });

  const recaptchaRef = React.useRef<ReCAPTCHA>(null);

  const mutation = useMutation({
    mutationFn: (data: { subject: string; message: string; token: string }) =>
      fetch(
        `/api/feedback?subject=${data.subject}&text=${data.message}&captcha=${data.token}`
      ).then((res) => res.json().then((response) => response)),
    onError: () => {
      notifications.show({
        title: "Ошибка",
        color: "red",
        icon: <IconAlertTriangle size="1rem" />,
        message: "Не удалось отправить сообщение, попробуйте еще раз",
        autoClose: 2000,
      });
    },
    onSuccess: () => {
      notifications.show({
        title: "Успех",
        color: "teal",
        icon: <IconCheck size="1rem" />,
        message: "Сообщение отправлено",
        autoClose: 2000,
      });
      form.reset();
    },
    onSettled: () => {
      recaptchaRef.current?.reset();
    },
  });

  const handleSubmit = () => {
    recaptchaRef.current?.execute();
  };

  const onReCAPTCHAChange = (token: string | null) => {
    if (!token) {
      return;
    }

    mutation.mutate({ ...form.values, token });
  };

  if (!process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY) {
    return;
  }

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
        onChange={onReCAPTCHAChange}
      />

      <Title order={2}>Обратная связь</Title>

      <Select
        label="Тема"
        data={["Предложение", "Я нашел баг", "Отзыв", "Другое"]}
        placeholder="Выберите тему"
        mt="md"
        name="subject"
        variant="filled"
        {...form.getInputProps("subject")}
      />
      <Textarea
        mt="md"
        label="Сообщение"
        placeholder="Начните писать здесь"
        maxRows={10}
        minRows={5}
        autosize
        name="message"
        variant="filled"
        {...form.getInputProps("message")}
      />

      <Group justify="center" mt="xl">
        <Button type="submit" size="md" loading={mutation.isPending}>
          Отправить
        </Button>
      </Group>
    </form>
  );
}
